<!--
 * @Description:联系人
 * @Author: cxh
 * @Date: 2022-05-24 15:19:34
 * @LastEditTime: 2023-03-24 15:01:44
 * @LastEditors: cxh
-->
<template>
  <cos-table v-bind="$attrs" :columns="columns" @fetch="fetch" ref="table">
    <template #bodyCell="{ column, record }">
      <template v-if="column.dataIndex === 'action'">
        <a-button type="link" @click="handleEdit(record)" v-permission="permissionPage?.edit">
          {{ t('btn.edit') }}
        </a-button>
        <a-button type="link" @click="handleDelete(record)" v-permission="permissionPage?.del">
          {{ t('btn.del') }}
        </a-button>
      </template>
    </template>
  </cos-table>
  <EditModal ref="editModalRef" @success="refresh" />
</template>
<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { message } from '@dc-platform/dc-components'
import Modal from '@/hooks/modalType'
import EditModal from './editModal.vue'
import dataConfig from '@/views/overseasSales/commonEnum/dataConfig'
import { customerContactList, customerContactDelete } from '@/api/overseasSales/customerCenter'
import type { PotentialItem } from '@/typings/api/customerCenter'
import { listByParamCodes } from '@/api/common'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const table = ref()
const editModalRef = ref()
const loading = ref(false)
const paramCodeData = ref<{
  fbu_area_code: []
}>({
  fbu_area_code: [] // 电话区号
})
const props = defineProps({
  disabled: {
    type: Boolean,
    default: true
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  contactRefId: {
    type: String
  },
  hideOk: {
    type: Boolean
  }
})
const fetch = (params: object, callBack: (res: any) => void) => {
  if (props.contactRefId) {
    customerContactList({
      contactRefId: props.contactRefId,
      ...params
    }).then((res) => {
      callBack(res)
    })
  }
}
onMounted(() => {
  getByParamCodes()
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_area_code']
  }).then((res) => {
    if (res.code === 200) {
      paramCodeData.value = res.data
    }
  })
}
const refresh = (type?: 'add' | 'edit') => {
  if (type === 'edit') {
    table.value.fetch()
  } else {
    table.value.search()
  }
}
// 编辑
const handleEdit = (row: PotentialItem['contact']) => {
  editModalRef.value.toggle(row)
}
// 删除
const handleDelete = (row: PotentialItem['contact']) => {
  Modal.delete({
    name: row.name,
    onOk() {
      loading.value = true
      customerContactDelete({
        id: row.id,
        contactRefId: row.contactRefId
      })
        .then((res) => {
          table.value.delFetch()
          message.success(t('tips.delSuccess'))
        })
        .finally(() => {
          loading.value = false
        })
    }
  })
}
const columns = computed(() => [
  {
    title: t('common.contactName'),
    dataIndex: 'name'
  },
  {
    title: t('common.mobile'),
    dataIndex: 'mobile'
  },
  {
    title: t('common.skype'),
    dataIndex: 'skype'
  },
  {
    title: t('common.email'),
    dataIndex: 'email'
  },
  {
    title: t('common.jobRole'),
    dataIndex: 'jobRole',
    dicData: dataConfig.linkRoleTypeEnum
  },
  {
    title: t('common.sex'),
    dataIndex: 'sex',
    dicData: dataConfig.genderEnum
  },
  {
    title: t('common.jobDuty'),
    dataIndex: 'jobDuty'
  },
  {
    title: t('common.action'),
    fixed: 'right',
    width: 120,
    dataIndex: 'action'
  }
])
defineExpose({
  refresh
})
</script>
<script lang="ts">
export default {
  name: 'ContactsTable'
}
</script>
